import React, { useState, useEffect } from 'react';
import './checkbox.scss';
export var Checkbox = function (props) {
    var label = props.label, value = props.value, id = props.id, classes = props.classes, checked = props.checked, disabled = props.disabled, isReset = props.isReset, className = props.className;
    var _a = useState(false), isChecked = _a[0], setChecked = _a[1];
    useEffect(function () {
        if (checked !== null && checked !== undefined) {
            setChecked(checked);
        }
    }, [checked]);
    useEffect(function () {
        if (isReset) {
            setChecked(false);
        }
    }, [isReset]);
    var onClickCheckbox = function () {
        props.onChecboxValueChanged(value, !isChecked);
        setChecked(!isChecked);
    };
    return (React.createElement("div", { className: "checkbox-wrapper " + (disabled ? "checkbox-wrapper-disable" : "") + " " + (className ? className : '') },
        React.createElement("label", { className: "checkbox-container " + ((classes === null || classes === void 0 ? void 0 : classes.label) ? classes === null || classes === void 0 ? void 0 : classes.label : '') },
            React.createElement("span", null, label),
            React.createElement("input", { type: "checkbox", checked: isChecked, disabled: disabled ? true : false, onChange: onClickCheckbox }),
            React.createElement("span", { className: "checkmark" }))));
};
export default Checkbox;
